import * as THREE from 'three';
import type { SkillEffect } from './skill-effects.js';
import { effectMaterial, shadeEffect } from './effect-surfaces.js';
import { distortionShell } from './howl-wave.js';

const DURATION = 2, PULSES = 4, ANGER = 0xc8503c;
/** Jagged, fast-shivering bands rather than the howl's smooth rings: a seething heat-haze. */
const SEETHE = 'sin(vWarp.y * 23.0 + sin(atan(vWarp.z, vWarp.x) * 9.0) * 1.6 - uTime * 31.0) * sin(atan(vWarp.z, vWarp.x) * 13.0 - uTime * 17.0)';

/** A goblin's mocking retaliation: a small, angry haze throbbing round the head of the hero who took the psychic damage. */
export function retaliationDistortion(height = 2, radius = .5): SkillEffect {
  const group = new THREE.Group(); group.name = 'retaliation-distortion';
  const { mesh, uniforms } = distortionShell('retaliation-distortion', SEETHE, 0xffd8d0, 2.5);
  const rim = new THREE.Mesh(new THREE.SphereGeometry(1, 32, 16), effectMaterial(ANGER, 0xff9a80, 1, .03));
  rim.name = 'retaliation-rim'; rim.userData.baseOpacity = .05;
  // The head sits about a ninth of the body's height below the crown.
  for (const shell of [mesh, rim]) { shell.position.y = height * .89; group.add(shell); }
  const across = Math.min(.34, radius * .55 + .08), tall = Math.min(.36, height * .15);
  return { group, duration: DURATION * 1000, update(p, _from, to, time = p * DURATION, ppm = 40) {
    group.position.copy(to);
    // A few throbs over two seconds, each a little weaker, ringing the head like a headache.
    const strength = Math.abs(Math.sin(p * Math.PI * PULSES)) ** .8 * (1 - p * .55);
    const swell = 1 + strength * .18;
    for (const shell of [mesh, rim]) shell.scale.set(across * swell, tall * swell, across * swell);
    mesh.visible = rim.visible = strength > .002;
    uniforms.uIor.value = 1 + .1 * strength; uniforms.uThickness.value = .4 * strength;
    uniforms.uTime.value = time; uniforms.uRipple.value = strength;
    shadeEffect(rim, time, strength, p, ppm);
  } };
}
